export default "__VITE_ASSET__Cf3BX7G4__"